import {Component} from '@angular/core';
import {NavigationComponent} from "./navigation/navigation.component";
import {SidebarComponent} from "./sidebar/sidebar.component";
import {RouterOutlet} from "@angular/router";

@Component({
    selector: 'app-page',
    templateUrl: './page.component.html',
    styleUrl: './page.component.scss',
    imports: [
        NavigationComponent,
        SidebarComponent,
        RouterOutlet
    ]
})
export class PageComponent {

}
